module.exports = "<div>\r\n  <div class=\"allowed-values\">\r\n    <label>{{ 'Input Values:' | translate }}</label>\r\n    <ul></ul>\r\n    <input type=\"text\" placeholder=\"value1, value2, otherValue\">\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./~/dmn-js/lib/table/features/type-row/TypeTemplate.html
// module id = 1167
// module chunks = 1